export default "__VITE_PUBLIC_ASSET__263573a2__"